import systemMessageRecieved from './system-message-recieved'
import types from '@/store/types'

export default (state, message) => {
  state[types.state.loading] = false
  systemMessageRecieved(state, message)
}
